import type { ProductBundleResponse, ProductStock, ProductStyle } from 'types/balder';

/** *
 * This function is used to filter productBundle asins according to the given asin list
 */
export default (asins: string[], response: ProductBundleResponse): ProductBundleResponse => {
  const uniqueAsins = new Set(asins);
  const removeInvalidStocksForExchangeApi = (stock: ProductStock) => uniqueAsins.has(stock.asin);
  const removeStylesWithoutStocks = (style: ProductStyle) => style.stocks.length > 0;
  const product = response.product?.[0] || { styles: [] };

  if (!response.product[0]) {
    return response;
  }

  return {
    ...response,
    product: [
      {
        ...response.product[0],
        styles: product.styles
          .map(style => ({
            ...style,
            stocks: style.stocks.filter(removeInvalidStocksForExchangeApi)
          }))
          .filter(removeStylesWithoutStocks)
      }
    ]
  };
};
